<template>
    <div class="BoxWide">
        <div class="TabellaGenerale Scadenzario">
            <input type="text" id="filtroAttivita" @change="this.changeAttivita($event)" style="display:none;">
            <input type="text" id="filtroCodiceEntita" @change="this.changeCodiceEntita($event)" style="display:none;">
            <input type="text" id="filtroDescrEntita" @change="this.changeDescrEntita($event)" style="display:none;">
            <input type="text" id="filtroDescrSito" @change="this.changeDescrSito($event)" style="display:none;">
            <input type="text" id="filtroDescrUnita" @change="this.changeDescrUnita($event)" style="display:none;">
            <input type="text" id="filtroDescrReparto" @change="this.changeDescrReparto($event)" style="display:none;">
            <input type="text" id="filtroDescrComparto" @change="this.changeDescrComparto($event)" style="display:none;">
            <input type="text" id="filtroResponsabile" @change="this.changeResponsabile($event)" style="display:none;">
            <input type="text" id="filtroTipoOrdinamento" @change="this.changeTipoOrd($event)" style="display:none;">
            <br/>
            <table width="100%" border="0" cellspacing="0" cellpadding="0">
                <tbody>
                    <tr>
                        <th scope="col">
                            <span class="TableFilterName">Attività</span>
                            <div class="TableFilter">
                                <form>
                                    <select class="CustomSelect NoSearch"  name="" id="selectAttivita">
                                        <option value="">Tutti</option>
                                        <option v-for="att in  Object.keys(this.opzioniAttivita)" :key="att" :value="att">{{this.opzioniAttivita[att]}}</option>                                      
                                    </select>
                                </form>
                            </div>
                        </th>
                        <th scope="col">
                            <span class="TableFilterName">Codice Entità</span>
                            <div class="TableFilter">
                                <form>
                                    <select class="CustomSelect NoSearch" name="" id="selectCodiceEntita">
                                        <option value="">Tutti</option>
                                        <option v-for="ent in Object.keys(this.opzioniCodiciEntita)" :key="ent" :value="ent">{{ent}}</option>                                       
                                    </select>
                                </form>
                            </div>
                        </th>
                        <th scope="col">
                            <span class="TableFilterName">Entità</span>
                            <div class="TableFilter">
                                <form>
                                    <select class="CustomSelect NoSearch" name="" id="selectDescrEntita">
                                        <option value="">Tutti</option>
                                        <option v-for="entDescr in Object.keys(this.opzioniDescrizioneEntita)" :key="entDescr" :value="entDescr">{{entDescr}}</option>                                  
                                    </select>
                                </form>
                            </div>
                        </th>
                        <th scope="col">
                            <span class="TableFilterName">Sito</span>
                            <div class="TableFilter">
                                <form>
                                    <select class="CustomSelect NoSearch" name="" id ="selectDescrSito">
                                        <option value="">Tutti</option>
                                        <option v-for="sitoDescr in Object.keys(this.opzioniDescrizioneSito)" :key="sitoDescr" :value="sitoDescr">{{sitoDescr}}</option>                                   
                                    </select>
                                </form>
                            </div>
                        </th>
                        <th scope="col">
                            <span class="TableFilterName">Unità</span>
                            <div class="TableFilter">
                                <form>
                                    <select class="CustomSelect NoSearch" name="" id="selectDescrUnita">
                                        <option value="">Tutti</option>
                                        <option v-for="unitaDescr in Object.keys(this.opzioniDescrizioneUnita)" :key="unitaDescr" :value="unitaDescr">{{unitaDescr}}</option>
                                    </select>
                                </form>
                            </div>
                        </th>
                        <th scope="col">
                            <span class="TableFilterName">Reparto</span>
                            <div class="TableFilter">
                                <form>
                                    <select class="CustomSelect NoSearch" name="" id="selectDescrReparto">
                                        <option value="">Tutti</option>
                                        <option v-for="repartoDescr in Object.keys(this.opzioniDescrizioneReparto)" :key="repartoDescr" :value="repartoDescr">{{repartoDescr}}</option>
                                    </select>
                                </form>
                            </div>
                        </th>
                        <th scope="col">
                            <span class="TableFilterName">Comparto</span>
                            <div class="TableFilter">
                                <form>
                                    <select class="CustomSelect NoSearch" name="" id="selectDescrComparto">
                                        <option value="">Tutti</option>
                                        <option v-for="compartoDescr in Object.keys(this.opzioniDescrizioneComparto)" :key="compartoDescr" :value="compartoDescr">{{compartoDescr}}</option>
                                    </select>
                                </form>
                            </div>
                        </th>
                        <th scope="col">
                            <span class="TableFilterName">Responsabile</span>
                            <div class="TableFilter">
                                <form>
                                    <select class="CustomSelect NoSearch" name="" id="selectResponsabile">
                                        <option value="">Tutti</option>
                                        <option v-for="responsabile in Object.keys(this.opzioniResponsabile)" :key="responsabile" :value="responsabile">{{responsabile}}</option>
                                    </select>
                                </form>
                            </div>
                        </th>
                        <th scope="col">
                            <span class="TableFilterName">Scad. manutenzione</span>
                            <div class = "TableFilter">
                                <form>
                                    <select class="CustomSelect NoSearch" name="" id="selectOrdScadenza">
                                        <option value="">Nessuno</option>
                                        <option value="asc">Crescente</option>
                                        <option value="desc">Decrescente</option>
                                    </select>
                                </form>
                            </div>
                        </th>
                    </tr>
                    <RigaGrigliaScadenzario v-for="scadenza, index in this.listaScadenzarioFilter" :key="index" 
                    :rigaScadenzario="scadenza"
                    >
                    </RigaGrigliaScadenzario>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

import RigaGrigliaScadenzario from "@/components/RigaGrigliaScadenzario.vue";

export default {
    name: "GrigliaScadenzario",
    components: {
        RigaGrigliaScadenzario
    },
    methods:{
        changeAttivita(e){          
            this.filtroAttivita = e.srcElement.value;
        },   
        changeCodiceEntita(e){
            this.filtroCodiceEntita = e.srcElement.value;
        },
        changeDescrEntita(e){
            this.filtroDescrEntita = e.srcElement.value;
        },
        changeDescrSito(e){
            this.filtroDescrSito = e.srcElement.value;
        },
        changeDescrUnita(e){
            this.filtroDescrUnita = e.srcElement.value;
        },       
        changeDescrReparto(e){
            this.filtroDescrReparto = e.srcElement.value;
        },
        changeDescrComparto(e){
            this.filtroDescrComparto = e.srcElement.value;
        },
        changeResponsabile(e){
            this.filtroResponsabile = e.srcElement.value;
        },
        changeTipoOrd(e){
            this.filtroTipoOrdinamento = e.srcElement.value;
        }         
    },
    data(){
        return {
            filtroAttivita: "",
            filtroCodiceEntita: "",
            filtroDescrEntita: "",
            filtroDescrSito: "",
            filtroDescrUnita: "",
            filtroDescrReparto: "",
            filtroDescrComparto: "",
            filtroResponsabile: "",
            filtroTipoOrdinamento: ""
        }
    },
    props: {
        listaScadenzario: Array
    },   
    computed: {       
        listaScadenzarioFilter(){

            let result =  this.listaScadenzario;
            
            if(this.filtroAttivita){
                result = result.filter(item => { return item.DescrAttivita === this.filtroAttivita});
            }

            if(this.filtroCodiceEntita){
                result = result.filter(item => {return item.CodiceEntita === this.filtroCodiceEntita});
            }

            if(this.filtroDescrEntita){
                result = result.filter(item => {return item.DescrEntita === this.filtroDescrEntita});
            }
            
            if(this.filtroDescrSito){
                result = result.filter(item => {return item.NomeSito === this.filtroDescrSito});
            }

            if(this.filtroDescrUnita){
                result = result.filter(item => {return item.DescrUnita === this.filtroDescrUnita});
            }

            if(this.filtroDescrReparto){
                result = result.filter(item => {return item.DescrReparto === this.filtroDescrReparto});
            }

            if(this.filtroDescrComparto){
                result = result.filter(item => {return item.DescrComparto === this.filtroDescrComparto});
            }

            if(this.filtroResponsabile){
                result = result.filter(item => {return item.Responsabile === this.filtroResponsabile});
            }

            if(this.filtroTipoOrdinamento){
                if(this.filtroTipoOrdinamento == "desc"){
                    result = result.sort((item1,item2) => {return new Date(item2.DataProssima) - new Date(item1.DataProssima)});
                }

                if(this.filtroTipoOrdinamento == "asc"){
                    result = result.sort((item1,item2) => {return new Date(item1.DataProssima) - new Date(item2.DataProssima)});
                }
            }

            return result;
        },

        opzioniAttivita(){
        
            var result = [];
            this.listaScadenzario.map(
                (element, index, array) => {
                    if(!result[element.DescrAttivita] && element.DescrAttivita !== null){                     
                        result[element.DescrAttivita] = element.DescrAttivita;
                    }                   
                },
                result
            );
            return result;
        },

        opzioniCodiciEntita(){
            var result = [];
            this.listaScadenzario.map(
                (element, index, array) => {
                    if(!result[element.CodiceEntita] && element.CodiceEntita !== null){                     
                        result[element.CodiceEntita] = element.CodiceEntita;
                    }                   
                },
                result
            );
            return result;
        },

        opzioniDescrizioneEntita(){
            var result = [];
            this.listaScadenzario.map(
                (element, index, array) => {
                    if(!result[element.DescrEntita] && element.DescrEntita !== null){                     
                        result[element.DescrEntita] = element.DescrEntita;
                    }                   
                },
                result
            );
            return result;
        },

        opzioniDescrizioneSito(){
            var result = [];
            this.listaScadenzario.map(
                (element, index, array) => {
                    if(!result[element.NomeSito] && element.NomeSito !== null){                     
                        result[element.NomeSito] = element.NomeSito;
                    }                   
                },
                result
            );
            return result;
        },

        opzioniDescrizioneUnita(){
            var result = [];
            this.listaScadenzario.map(
                (element, index, array) => {
                    if(!result[element.DescrUnita] && element.DescrUnita !== null){                     
                        result[element.DescrUnita] = element.DescrUnita;
                    }                   
                },
                result
            );
            return result;
        },

        opzioniDescrizioneReparto(){
            var result = [];
            this.listaScadenzario.map(
                (element, index, array) => {
                    if(!result[element.DescrReparto] && element.DescrReparto !== null){                     
                        result[element.DescrReparto] = element.DescrReparto;
                    }                   
                },
                result
            );
            return result;
        },

        opzioniDescrizioneComparto(){
            var result = [];
            this.listaScadenzario.map(
                (element, index, array) => {
                    if(!result[element.DescrComparto] && element.DescrComparto !== null){                     
                        result[element.DescrComparto] = element.DescrComparto;
                    }                   
                },
                result
            );
            return result;
        },

        opzioniResponsabile(){
            var result = [];
            this.listaScadenzario.map(
                (element, index, array) => {
                    if(!result[element.Responsabile] && element.Responsabile !== null){                     
                        result[element.Responsabile] = element.Responsabile;
                    }                   
                },
                result
            );
            return result;
        }
    },   
    updated(){
        $('#selectAttivita').select2({
            theme: "classic",          
        });
        
        $('#selectCodiceEntita').select2({
            theme: "classic",          
        });

        $('#selectDescrEntita').select2({
            theme: "classic",          
        });

        $('#selectDescrSito').select2({
            theme: "classic",          
        });

        $('#selectDescrUnita').select2({
            theme: "classic",          
        });

        $('#selectDescrReparto').select2({
            theme: "classic",          
        });

        $('#selectDescrComparto').select2({
            theme: "classic",          
        });

        $('#selectResponsabile').select2({
            theme: "classic",          
        });

        $('#selectOrdScadenza').select2({
            theme: "classic",          
        });
    },
    mounted(){

        $("#selectAttivita").on('select2:select', function (e) {  
            var codiceEsito = e.params.data.id;        
            $("#filtroAttivita").val(codiceEsito);   
            document.getElementById("filtroAttivita").dispatchEvent(new Event('change'));            
        });  
            
        $("#selectCodiceEntita").on('select2:select', function (e) {  
            var codiceEsito = e.params.data.id;        
            $("#filtroCodiceEntita").val(codiceEsito);   
            document.getElementById("filtroCodiceEntita").dispatchEvent(new Event('change'));            
        }); 

        $("#selectDescrEntita").on('select2:select', function (e) {  
            var codiceEsito = e.params.data.id;        
            $("#filtroDescrEntita").val(codiceEsito);   
            document.getElementById("filtroDescrEntita").dispatchEvent(new Event('change'));            
        }); 

        $("#selectDescrSito").on('select2:select', function (e) {  
            var codiceEsito = e.params.data.id;        
            $("#filtroDescrSito").val(codiceEsito);   
            document.getElementById("filtroDescrSito").dispatchEvent(new Event('change'));            
        }); 

        $("#selectDescrUnita").on('select2:select', function (e) {  
            var codiceEsito = e.params.data.id;        
            $("#filtroDescrUnita").val(codiceEsito);   
            document.getElementById("filtroDescrUnita").dispatchEvent(new Event('change'));            
        });

        $("#selectDescrReparto").on('select2:select', function (e) {  
            var codiceEsito = e.params.data.id;        
            $("#filtroDescrReparto").val(codiceEsito);   
            document.getElementById("filtroDescrReparto").dispatchEvent(new Event('change'));            
        }); 

        $("#selectDescrComparto").on('select2:select', function (e) {  
            var codiceEsito = e.params.data.id;        
            $("#filtroDescrComparto").val(codiceEsito);   
            document.getElementById("filtroDescrComparto").dispatchEvent(new Event('change'));            
        });

        $("#selectResponsabile").on('select2:select', function (e) {  
            var codiceEsito = e.params.data.id;        
            $("#filtroResponsabile").val(codiceEsito);   
            document.getElementById("filtroResponsabile").dispatchEvent(new Event('change'));            
        }); 

        $("#selectOrdScadenza").on('select2:select', function (e) {  
            var codiceEsito = e.params.data.id;        
            $("#filtroTipoOrdinamento").val(codiceEsito);   
            document.getElementById("filtroTipoOrdinamento").dispatchEvent(new Event('change'));            
        });  
    }    
}
</script>